import React from "react";
import Navbar from "@/components/Navbar";
import { Crosshair } from "@/components/Crosshair";

// Final, approved About copy — rendered as a clean readable article on the site's standard
// page shell (Navbar header + centered container) using the existing type + color system.
const PARAGRAPHS = [
  <>
    Every optics forum has a for-sale section, and they all work the same way: PayPal friends and
    family, wire the money and hope, meet a stranger from the internet in a parking lot. No
    verification, no recourse. If it goes wrong, it's a screenshot and a bad feeling — that's the
    whole system.
  </>,
  <>
    OpticSwap fixes that. <strong className="text-foreground font-semibold">Every member verifies
    their identity before they can buy or sell</strong> — real name, real ID, checked once. You
    always know who's actually on the other end. <strong className="text-foreground font-semibold">Payment
    is held until the buyer confirms the item arrived as described</strong>; if it doesn't match the
    listing, the money doesn't move.
  </>,
  <>
    Search is built for this gear specifically — reticle, focal plane, tube size, MOA or MRAD,
    magnification, mount spec. Built for the hunting, shooting, and tactical space.
  </>,
  <>There's a forum too, because everyone loves some friendly banter.</>,
  <>If something's off, say so. It gets fixed.</>,
];

export default function About() {
  return (
    <div className="min-h-screen text-foreground" data-testid="about-page">
      <Navbar />
      <div className="max-w-[760px] mx-auto px-4 py-16 sm:py-20">
        {/* eyebrow + lead statement */}
        <div className="animate-fade-up">
          <span className="font-mono text-[10px] uppercase tracking-[3.4px] text-volt" data-testid="about-eyebrow">
            About OpticSwap
          </span>
          <h1
            className="mt-5 font-heading text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight leading-[1.12]"
            data-testid="about-lead"
          >
            OpticSwap was built because the way people already buy and sell this gear doesn't work.
          </h1>
        </div>

        <Crosshair className="my-12" />

        {/* body — each paragraph its own block */}
        <div className="space-y-7">
          {PARAGRAPHS.map((p, i) => (
            <p
              key={i}
              className="text-base sm:text-lg text-secondary-foreground font-body leading-relaxed animate-fade-up"
              style={{ animationDelay: `${0.06 * (i + 1)}s` }}
              data-testid={`about-para-${i + 1}`}
            >
              {p}
            </p>
          ))}
        </div>

        {/* closing statement */}
        <div
          className="mt-12 border-l-2 border-olive bg-surface px-6 py-7 sm:px-8 animate-fade-up"
          style={{ animationDelay: "0.42s" }}
          data-testid="about-closing"
        >
          <p className="font-heading text-xl sm:text-2xl font-bold tracking-tight leading-snug text-foreground">
            That's OpticSwap: a marketplace built on{" "}
            <span className="text-olive-bright">trust and validity</span>.
          </p>
        </div>
      </div>
    </div>
  );
}
